(function ($) {
    'use strict';
    $.fn.branchSearchPost = function (options) {
        // Default settings
        var settings = $.extend({
            targetContainerSelector: "#target-list",
            url: "",
            isGeoSearch: false,
        }, options);

        var onSuccess = function (data) {
            $(settings.targetContainerSelector).html(data);

            var searchInput = $('input.branch-search:first');

            // Multiply by 2 to ensure the cursor always ends up at the end;
            // Opera sometimes sees a carriage return as 2 characters.
            //var strLength = searchInput.val().length * 2;
            if (settings.isGeoSearch)
                $('input.branch-search:first').val('');
            searchInput.focus();
            //searchInput[0].setSelectionRange(strLength, strLength);
        }

        var onFailure = function (data) {
            console.log(data);
        }

        var getAjaxParameters = function (htmlControl) {
            var $form = $(htmlControl).closest("form");

            return {
                url: $form.attr("action"),
                method: $form.attr("method"),
                data: $form.serialize()
            }
        }

        var ajaxCall = function (e) {
            e.preventDefault();
            var ajaxParams = getAjaxParameters(this);
            $.ajax({
                method: ajaxParams.method,
                url: ajaxParams.url,
                data: ajaxParams.data,
                success: onSuccess,
                failure: onFailure
            });
        }
        this.unbind("click");
        this.click(ajaxCall);


        return this.click();
    };

}(jQuery));

function showbranchSelection() {
    if ($('a#user-SelectedBranchName').hasClass('active')) {
        $('a#user-SelectedBranchName').removeClass('active')
        $('.header-bottom .selection-box').slideUp(350);
    }
    else {
        $('a#user-SelectedBranchName').addClass('active');
        $('.header-bottom .selection-box').slideDown(350);
    }
}

(function ($) {
    'use strict';
    $.fn.clickSelection = async function (e) {
        const antiForgeryToken = $('input[name="__RequestVerificationToken"]').val();
        const $button = $(this);
        const itemId = $button.data('id');
        const isAuthenticated = $button.data('login');

        /**
         * Handle the selection of a user branch.
         */
        await Set_SelectedBranch(itemId, isAuthenticated, antiForgeryToken, Show_PopupOnPage());

        /**
        * Update Components on Page
        */
        Update_ComponentOnPage(antiForgeryToken, itemId);

        setTimeout(() => {
            loadAddressFinder('searchAULocation');
        }, 500);
    };
}(jQuery));

function Show_PopupOnPage () {
    const path = window.location.pathname;
    return (path === '/' || /^\/c\//.test(path) || /^\/p\//.test(path))
}

function Update_ComponentOnPage(token, itemId) {

    if (window.location.pathname === '/')
        Refresh_PopularProducts(token)

    if (/^\/c\//.test(window.location.pathname))
        window.reloadMiddysProductListing()

    if (/^\/p\//.test(window.location.pathname)) {
        window.reloadProductDetailComponent()

        //Update branch selection in stock availability
        const stockStatusElement = $('#selected-branch-stock');
        const selectedElement = $('#' + itemId + '_stock_status')
        stockStatusElement.empty(); // Clear existing content
        stockStatusElement.removeClass().addClass(selectedElement.attr('class')).text(selectedElement.text())
        $('#selected-branch-name').text($('#' + itemId + '_name').text())
        $('#selected-branch-address').text($('#' + itemId + '_address').text())
    }

    if (window.location.pathname === '/cart')
        window.reloadCartComponent()
}

function loadAddressFinder(targetInputId) {
    const uniqueListId = `${targetInputId}-suggestions-list`;
    $(`#${uniqueListId}`).remove();
    $(`#${targetInputId}`).off();

    new AddressFinder({
        targetInputId: targetInputId,
        showAddresses: false,
        showLocations: true,
        suggestionsListId: uniqueListId, 
        onSelect: function (fullAddress, metaData) {
            $("input[id='searchBranchLatitude']").val(metaData.latitude);
            $("input[id='searchBranchLongitude']").val(metaData.longitude);
            $("input#branch-search-submit").click();
            $("a#user-SelectedBranchName").click();
            $('.custom-select, .field-wrap select').select2({
                minimumResultsForSearch: Infinity,
                width: 'style',
            });
            showbranchSelection();
        }
    });
}

$(document).ready(function () {
    loadAddressFinder('searchAULocation')
});


